'use client'
import { getCurrentUser } from '@src/quince-site-integrated/src/utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { isEmpty } from '@src/utils/functions/utils'

export function useGladlyChat() {
  const { name, email } = getCurrentUser()
  const setGladlyUser = () => {
    if (email && !isEmpty(window.Gladly.getUser())) {
      try {
        window.Gladly.setUser({ name, identity: email, identityType: 'EMAIL' })
      } catch (error) {
        console.error(error)
      }
    }
  }

  const openChat = () => {
    try {
      window.Gladly.show()
      trackEvent(TELEMETRY_EVENT_NAMES.CHAT_WITH_US_CLICKED, {})
      setGladlyUser()
    } catch (error) {
      console.error(error)
    }
  }

  return { openChat }
}
